import { render } from "./OProfileCompletionModal.vue?vue&type=template&id=054f1938&scoped=true"
import script from "./OProfileCompletionModal.vue?vue&type=script&lang=js"
export * from "./OProfileCompletionModal.vue?vue&type=script&lang=js"

import "./OProfileCompletionModal.vue?vue&type=style&index=0&id=054f1938&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054f1938"]])

export default __exports__